<template>
  <div v-if="events.length > 0" class="w-full max-w-6xl">
    <div class="text-light w-full grid lg:grid-cols-2 grid-cols-1 gap-4">
      <div
        v-for="(item, i) in events"
        :key="i"
        class="expo-event_card relative bg-expo_dblue w-full h-36 flex flex-col space-y-1 text-white justify-start items-start p-4 z-10 rounded overflow-hidden"
      >
        <div
          v-if="item.image"
          class="w-full h-full absolute top-0 left-0 right-0 bottom-0 bg-no-repeat bg-cover bg-center"
          :style="{ backgroundImage: 'url(' + item.image + ')' }"
        ></div>

        <div class="z-10">
          <p class="text-sm text-left">{{ item.date_range }}</p>
          <h3 class="font-poppins font-normal text-left">{{ item.title }}</h3>
        </div>

        <div
          class="w-full absolute bottom-0 left-0 h-12 flex justify-between items-center px-4 z-10"
        >
          <button
            type="button"
            class="text-white uppercase underline-none flex hover:underline justify-center items-center transform transition-all duration-300 ease-in-out"
            @click="goToEvent(item.slug)"
          >
            <span class="font-bold text-xs font-poppins">Show Details</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <a
            class="hover:bg-expo_red hover:text-white bg-gray-900 relative font-bold px-2 py-1 rounded transform transition-all duration-300 ease-in-out font-bold text-xs font-poppins uppercase no-underline"
            target="_blank"
            :href="settings.cloud_url + '?event=' + item.id"
            >Exhibitor Profiles</a
          >
        </div>
      </div>

      <div
        class="expo-event_card relative bg-expo_dblue w-full h-36 flex flex-col space-y-1 text-white justify-start items-start p-4 z-10 rounded overflow-hidden"
      >
        <a ref="onlineExpoLink" class="hidden" :href="settings.cloud_url"></a>
        <div
          class="w-full h-full absolute top-0 left-0 right-0 bottom-0 bg-no-repeat bg-cover bg-center"
          :style="{ backgroundImage: 'url(' + onlineBG + ')' }"
        ></div>

        <div class="z-10">
          <p class="text-sm text-left">Year Round</p>
          <h3 class="font-poppins font-normal text-left">Online Expo</h3>
        </div>

        <div
          class="w-full absolute bottom-0 left-0 h-12 flex justify-between items-center px-4 z-10"
        >
          <button
            type="button"
            class="text-white uppercase underline-none flex hover:underline justify-center items-center transform transition-all duration-300 ease-in-out"
            @click="goToOnlineExpo()"
          >
            <span class="font-bold text-xs font-poppins">View Online Expo</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <a
      class="btn btn-expo-red stand-btn no-underline h-16 mt-16 text-xl mx-auto"
      @click="goToBookAStand()"
      >Book your stands</a
    >

    <p
      :class="enquiryActiveStep > 0 ? 'invisible' : ''"
      class="italic text-center my-4"
    >
      or
    </p>

    <div class="w-full flex items-center justify-center h-24">
      <div
        class="w-full lg:w-1/3 mx-auto w-full relative flex items-center justify-center"
      >
        <div
          :class="
            enquiryActiveStep === 0
              ? 'opacity-100'
              : 'opacity-0 pointer-events-none absolute'
          "
          class="w-full transition-all duration-300 ease-in-out flex items-center justify-center"
        >
          <button
            class="w-full pt-0 text-center mx-auto btn border-transparent hover:border-black hover:text-expo_red hover:bg-transparent mx-auto underline"
            @click="enquiryActiveStep = 1"
          >
            Register your interest
          </button>
        </div>

        <div
          :class="
            enquiryActiveStep === 1
              ? 'opacity-100'
              : 'opacity-0 pointer-events-none absolute'
          "
          class="w-full transition-all duration-300 ease-in-out flex flex-col items-center justify-center"
        >
          <div class="flex w-full">
            <input
              id="enquiryEmail"
              v-model="enquiryEmail"
              class="placeholder-truegray-700 border-truegray-300 focus:border-truegray-700 text-gray-700 focus:text-gray-700 visited:text-gray-700 focus:ring-gray-700 flex-grow px-4 m-0 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-l-lg relative bg-white border absolute w-full left-0 top-0 text-center mx-auto"
              name="enquiryEmail"
              type="email"
              autocomplete="off"
              placeholder="Enter your email address"
            />
            <button
              class="btn btn-expo-red w-16 h-12 flex-shrink-0 relative right-2"
              @click="submitEnquiry"
            >
              <div
                class="absolute inset-0 w-full flex justify-center items-center z-20"
              >
                <lottie v-if="thinking" :options="loadingAnimationOptions" />
              </div>
              <span :class="[thinking ? 'invisible' : '']">Submit</span>
            </button>
          </div>

          <button
            class="italic underline font-bold border-none background-none text-xs"
            @click="enquiryActiveStep = 0"
          >
            cancel
          </button>
        </div>

        <div
          :class="
            enquiryActiveStep === 2
              ? 'opacity-100'
              : 'opacity-0 pointer-events-none absolute'
          "
          class="w-full transition-all duration-300 ease-in-out flex flex-col items-center justify-center text-green-500"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <p class="text-xl mt-1">Your enquiry has been sent!</p>
          <p class="text-truegray-700 mt-4 italic text-xs">
            The team will be in touch as soon as possible.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../shared/components/loading.json'
import { mapGetters } from 'vuex'

export default {
  mixins: [shared],

  data() {
    return {
      enquiryActiveStep: 0,
      enquiryEmail: '',
      thinking: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      showOnlineCta: false,
      onlineBG: '/img/careers-expo-exhibitors.jpg',
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      events: 'expo/getEvents',
    }),
  },

  watch: {
    events: {
      handler: function (arr) {
        let showOnlineCta = arr.length % 2 === 0 ? false : true
        this.$set(this, 'showOnlineCta', showOnlineCta)
      },

      deep: true,
    },
  },

  methods: {
    goToEvent(slug) {
      // Be wary of pushing to the same template
      // If on the event template already we need to replace
      // If not on the event template we can push
      if (this.$router.history.current.name === 'Event') {
        this.$router.replace({ path: '/event/' + slug, params: { slug: slug } })
      } else {
        this.$router.push({ path: '/event/' + slug })
      }
    },

    goToExhibitors() {
      this.$refs.id + 'viewExhibitor'.click()
    },

    goToBookAStand() {
      this.$router.push({ name: 'ExhibitorRegistration' })
    },

    goToOnlineExpo() {
      this.$refs.onlineExpoLink.click()
    },

    submitEnquiry() {
      this.$set(this, 'thinking', true)

      axios
        .post('/api/expo-stand-enquiry', { email: this.enquiryEmail })
        .then((response) => {
          this.$set(this, 'thinking', false)

          let returned = response.data

          if (returned.success) {
            this.$set(this, 'emailSubmitResponseSuccess', true)
            EventBus.$emit('triggerAlertResponse', {
              status: 'success',
              message:
                'Your email has been sent. The team will be in touch soon!',
            })
          } else {
            EventBus.$emit('triggerAlertResponse', {
              status: 'error',
              message: 'Something went wrong!',
            })
          }
          this.enquiryActiveStep = 2
          this.enquiryEmail = ''
        })
    },
  },
}
</script>

<style scoped>
.expo-event_card::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  background: linear-gradient(
    270deg,
    rgba(5, 22, 46, 0.6) 20.39%,
    rgba(5, 22, 46, 0) 61.02%,
    rgba(5, 22, 46, 0.6) 100%
  );
}

@media screen and (min-width: 1024px) {
  .stand-btn {
    width: 25rem;
  }
}
</style>
